import { getAutoSavedLayoutKeys } from "@qw/ui";
import { INBOX_LIST_THREAD_LAYOUT_STORAGE_KEY } from "../inbox/inbox-list-thread-layout";
import { INBOX_RAIL_LAYOUT_STORAGE_KEY } from "../inbox/inbox-rail-layout";
import { INBOX_SIDE_PANEL_WIDTHS_STORAGE_KEY } from "../inbox/inbox-shell-layout";

/**
 * Canonical registry of inbox layout localStorage keys that live outside the
 * shared react-resizable-panels autosave (the fixed side-panel widths, the
 * list/thread orientation and the rail mode). Add new inbox layout storage keys
 * here so "Reset layout" keeps clearing all of them.
 */
export const INBOX_LAYOUT_STORAGE_KEYS = [
  INBOX_SIDE_PANEL_WIDTHS_STORAGE_KEY,
  INBOX_LIST_THREAD_LAYOUT_STORAGE_KEY,
  INBOX_RAIL_LAYOUT_STORAGE_KEY,
];

/**
 * Collects every localStorage key that holds inbox panel geometry — the shared
 * panel autosave entries plus the inbox-specific keys above. A corrupt value in
 * any of these can strand the layout (e.g. the inbox squeezed to an unusable
 * sliver), which historically has only been recoverable by clearing all site
 * storage from devtools — which also logs the user out.
 */
export const getInboxLayoutStorageKeys = (storage: Storage): string[] => [
  ...new Set([...INBOX_LAYOUT_STORAGE_KEYS, ...getAutoSavedLayoutKeys(storage)]),
];

/**
 * Clears persisted inbox panel geometry and reloads so the layout rebuilds from
 * defaults. Unlike clearing all site storage, this leaves auth state intact, so
 * the user does not have to sign back in.
 */
export const resetInboxLayout = () => {
  try {
    for (const key of getInboxLayoutStorageKeys(window.localStorage)) {
      window.localStorage.removeItem(key);
    }
  } catch {
    // If storage is unavailable there is nothing to clear; still reload below so
    // the user gets a clean render from whatever in-memory state remains.
  }

  window.location.reload();
};
